export default "__VITE_ASSET__BOWgZ7oD__"